/**
 * @generated SignedSource<<7de08b41c0233f993e9f465f2b55ff1d>>
 * @relayHash 2abd4ad2e8912c8629a5da83f2373cce
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 1f5d76d0b50d1729fc79fb483dbf5fd8a89c1dcdb99beeede2b23b9584cca1ac

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { srcVirtualAgentBrowseIntentsStatisticsQuery } from './srcVirtualAgentBrowseIntentsStatisticsQuery.graphql';

import newPerformancePage_provider from '@atlassian/jira-relay-provider/src/jsm-va-enable-performance-page.relayprovider';

const node: PreloadableConcreteRequest<srcVirtualAgentBrowseIntentsStatisticsQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "1f5d76d0b50d1729fc79fb483dbf5fd8a89c1dcdb99beeede2b23b9584cca1ac",
    "metadata": {},
    "name": "srcVirtualAgentBrowseIntentsStatisticsQuery",
    "operationKind": "query",
    "text": null,
    "providedVariables": {
      "__relay_internal__pv__atlassianjirarelayprovidersrcjsmvaenableperformancepagerelayprovider": newPerformancePage_provider
    }
  }
};

export default node;
